export enum FreidaRoles {
  AmaMemberRole = 'ama_member',
  AuthenticatedUser = 'authenticated',
  ProgramMaintainer = 'program_maintainer'
}
